export class CustomExcelError extends Error {
    constructor(
        public status: number,
        public excelCode: CustomFunctions.ErrorCode,
        message: string
    ) {
        super(message);
    }
}